$(document).ready(function(){
    $('.custom-image-slider').slick({
        infinite: true,  // Enable infinite scrolling
        slidesToShow: 3, // Number of slides to show at once
        slidesToScroll: 3, // Number of slides to scroll at once
        arrows: false,  // Show next/prev arrows
        dots: true,    // Show navigation dots
        autoplay: true, // Enable autoplay
        autoplaySpeed: 4000, // Speed of autoplay in milliseconds
        centerMode: true, // Enable center mode
    });
});